import apiClient from '../../../api/client';
import { API_ENDPOINTS } from '../../../constants/apiEndpoints';

/**
 * Feature Flags API — public runtime flags (no auth) and admin flags (admin only)
 */
export const featureFlagsApi = {
    /**
     * Get public flags — safe for unauthenticated clients.
     * GET /api/feature-flags/public
     * Returns only allowlisted flags: payments, product_ordering, maintenance.
     */
    async getPublicFlags() {
        const response = await apiClient.get('/api/feature-flags/public');
        // Handle both { success, data: { flags } } and direct shape
        const flags = response?.data?.flags || response?.flags || [];
        return flags;
    },

    /**
     * Get all flags (admin only) — for admin settings page.
     * Kept for backward compatibility with Billing module.
     */
    async getAdminFlags() {
        const response = await apiClient.get(API_ENDPOINTS.BILLING.FEATURE_FLAGS || '/api/admin/feature-flags');
        const flags = response?.data?.flags || response?.flags || [];
        return flags;
    },
};

export default featureFlagsApi;
